import {Rule} from '../../models/svg-rule/rule.model';
import {IRuleSystem} from '../../models/svg-rule/rule-system.model';
import {Color} from '../../enums/color';
import {TcddTrainTabUtil, ValueIndex} from '../../utils/tcdd-train-tab-util';
import {TcddMainSystem} from '../../enums/tcdd-main-system.enum';
import {TcddSubSystem} from '../../enums/tcdd-sub-system.enum';
import {TcddSubSystemType} from '../../enums/tcdd-sub-system-type.enum';
import {SignalizationSystemKeys} from '../../constants/tcdd-system-keys/signalization-system-keys';
import {TCDD_UNIT} from '../../constants/tcdd-unit-constant';
import {SIGNALIZATION_SYSTEM} from '../../constants/tcdd-system-contants/signalization-system.constant';
import {createColorRule} from '../../utils/tcdd-rule-util';

function getIndex(key: string): ValueIndex {
  return TcddTrainTabUtil.getValueIndex(
    TcddMainSystem.DIAGNOSTIC_SYSTEM,
    TcddSubSystem.SIGNALIZATION_SYSTEM,
    TcddSubSystemType.SUB,
    key
  );
}

export class SignalizationSystemRules implements IRuleSystem {
  public getRules(): Rule[] {
    return [
      createColorRule(TCDD_UNIT.ETCS_CABINET, (wagonIndex: number, data: any[], setColor: (color: Color) => void) => {
        const wagonData = data?.[TcddSubSystem.SIGNALIZATION_SYSTEM]?.[wagonIndex];
        if (!wagonData) return false;

        const btm: ValueIndex = getIndex(SignalizationSystemKeys.btm); // === 1 will be red
        const jru: ValueIndex = getIndex(SignalizationSystemKeys.jru); // === 1 will be red
        const rtm: ValueIndex = getIndex(SignalizationSystemKeys.rtm); // === 1 will be red
        const evc: ValueIndex = getIndex(SignalizationSystemKeys.evc); // === 1 will be red
        const nvc: ValueIndex = getIndex(SignalizationSystemKeys.nvc); // === 1 will be red
        const psu: ValueIndex = getIndex(SignalizationSystemKeys.psu); // === 1 will be red
        const dmiStatus: ValueIndex = getIndex(SignalizationSystemKeys.dmiStatus); // === 3 || === 4 will be red
        const dmiError: ValueIndex = getIndex(SignalizationSystemKeys.dmiError); // === 1 will be red
        const tacho1Broken: ValueIndex = getIndex(SignalizationSystemKeys.tacho1Broken); // === 1 will be red
        const tacho2Broken: ValueIndex = getIndex(SignalizationSystemKeys.tacho2Broken); // === 1 will be red
        const doppler1Broken: ValueIndex = getIndex(SignalizationSystemKeys.doppler1Broken); // === 1 will be red
        const doppler2Broken: ValueIndex = getIndex(SignalizationSystemKeys.doppler2Broken); // === 1 will be red
        const dmiTemperatureError: ValueIndex = getIndex(SignalizationSystemKeys.dmiTemperatureError); // === 1 will be yellow
        const dmiFanError: ValueIndex = getIndex(SignalizationSystemKeys.dmiFanError); // === 1 will be yellow

        if ( // Red state
          Number(wagonData[btm.groupIndex]?.[btm.infoIndex]) === SIGNALIZATION_SYSTEM.STATUS.BTM_ERROR ||
          Number(wagonData[jru.groupIndex]?.[jru.infoIndex]) === SIGNALIZATION_SYSTEM.STATUS.JRU_ERROR ||
          Number(wagonData[rtm.groupIndex]?.[rtm.infoIndex]) === SIGNALIZATION_SYSTEM.STATUS.RTM_ERROR ||
          Number(wagonData[evc.groupIndex]?.[evc.infoIndex]) === SIGNALIZATION_SYSTEM.STATUS.EVC_ERROR ||
          Number(wagonData[nvc.groupIndex]?.[nvc.infoIndex]) === SIGNALIZATION_SYSTEM.STATUS.NVC_ERROR ||
          Number(wagonData[psu.groupIndex]?.[psu.infoIndex]) === SIGNALIZATION_SYSTEM.STATUS.PSU_ERROR ||
          Number(wagonData[dmiStatus.groupIndex]?.[dmiStatus.infoIndex]) === SIGNALIZATION_SYSTEM.DMI_STATUS_ERROR_1 ||
          Number(wagonData[dmiStatus.groupIndex]?.[dmiStatus.infoIndex]) === SIGNALIZATION_SYSTEM.DMI_STATUS_ERROR_2 ||
          Number(wagonData[dmiError.groupIndex]?.[dmiError.infoIndex]) === SIGNALIZATION_SYSTEM.STATUS.DMI_ERROR ||
          Number(wagonData[tacho1Broken.groupIndex]?.[tacho1Broken.infoIndex]) === SIGNALIZATION_SYSTEM.STATUS.TACHO_BROKEN ||
          Number(wagonData[tacho2Broken.groupIndex]?.[tacho2Broken.infoIndex]) === SIGNALIZATION_SYSTEM.STATUS.TACHO_BROKEN ||
          Number(wagonData[doppler1Broken.groupIndex]?.[doppler1Broken.infoIndex]) === SIGNALIZATION_SYSTEM.STATUS.DOPPLER_BROKEN ||
          Number(wagonData[doppler2Broken.groupIndex]?.[doppler2Broken.infoIndex]) === SIGNALIZATION_SYSTEM.STATUS.DOPPLER_BROKEN
        ) {
          setColor(Color.Red);
          return true;
        }

        if ( // Yellow state
          Number(wagonData[dmiTemperatureError.groupIndex]?.[dmiTemperatureError.infoIndex]) === SIGNALIZATION_SYSTEM.STATUS.DMI_TEMP_ERROR ||
          Number(wagonData[dmiFanError.groupIndex]?.[dmiFanError.infoIndex]) === SIGNALIZATION_SYSTEM.STATUS.DMI_FAN_ERROR
        ) {
          setColor(Color.Yellow);
          return true;
        }

        return false;
      }),
      createColorRule(TCDD_UNIT.DMI, (wagonIndex: number, data: any[], setColor: (color: Color) => void) => {
        const wagonData = data?.[TcddSubSystem.SIGNALIZATION_SYSTEM]?.[wagonIndex];
        if (!wagonData) return false;

        const dmiStatus: ValueIndex = getIndex(SignalizationSystemKeys.dmiStatus); // === 3 || === 4 will be red
        const dmiError: ValueIndex = getIndex(SignalizationSystemKeys.dmiError); // === 1 will be red
        const dmiTemperatureError: ValueIndex = getIndex(SignalizationSystemKeys.dmiTemperatureError); // === 1 will be yellow
        const dmiFanError: ValueIndex = getIndex(SignalizationSystemKeys.dmiFanError); // === 1 will be yellow

        if ( // Red state
          Number(wagonData[dmiStatus.groupIndex]?.[dmiStatus.infoIndex]) === SIGNALIZATION_SYSTEM.DMI_STATUS_ERROR_1 ||
          Number(wagonData[dmiStatus.groupIndex]?.[dmiStatus.infoIndex]) === SIGNALIZATION_SYSTEM.DMI_STATUS_ERROR_2 ||
          Number(wagonData[dmiError.groupIndex]?.[dmiError.infoIndex]) === SIGNALIZATION_SYSTEM.STATUS.DMI_ERROR
        ) {
          setColor(Color.Red);
          return true;
        }

        if ( // Yellow state
          Number(wagonData[dmiTemperatureError.groupIndex]?.[dmiTemperatureError.infoIndex]) === SIGNALIZATION_SYSTEM.STATUS.DMI_TEMP_ERROR ||
          Number(wagonData[dmiFanError.groupIndex]?.[dmiFanError.infoIndex]) === SIGNALIZATION_SYSTEM.STATUS.DMI_FAN_ERROR
        ) {
          setColor(Color.Yellow);
          return true;
        }

        return false;
      }),
      createColorRule(TCDD_UNIT.ETCS_CAB_1, (wagonIndex: number, data: any[], setColor: (color: Color) => void) => {
        const wagonData = data?.[TcddSubSystem.SIGNALIZATION_SYSTEM]?.[wagonIndex];
        if (!wagonData) return false;

        const rtm: ValueIndex = getIndex(SignalizationSystemKeys.rtm); // === 1 will be red

        if ( // Red state
          Number(wagonData[rtm.groupIndex]?.[rtm.infoIndex]) === SIGNALIZATION_SYSTEM.STATUS.RTM_ERROR
        ) {
          setColor(Color.Red);
          return true;
        }

        return false;
      }),
      createColorRule(TCDD_UNIT.ETCS_CAB_2, (wagonIndex: number, data: any[], setColor: (color: Color) => void) => {
        const wagonData = data?.[TcddSubSystem.SIGNALIZATION_SYSTEM]?.[wagonIndex];
        if (!wagonData) return false;

        const jru: ValueIndex = getIndex(SignalizationSystemKeys.jru); // === 1 will be red
        const psu: ValueIndex = getIndex(SignalizationSystemKeys.psu); // === 1 will be red
        const evc: ValueIndex = getIndex(SignalizationSystemKeys.evc); // === 1 will be red
        const nvc: ValueIndex = getIndex(SignalizationSystemKeys.nvc); // === 1 will be red
        const btm: ValueIndex = getIndex(SignalizationSystemKeys.btm); // === 1 will be red

        if ( // Red state
          Number(wagonData[jru.groupIndex]?.[jru.infoIndex]) === SIGNALIZATION_SYSTEM.STATUS.JRU_ERROR ||
          Number(wagonData[psu.groupIndex]?.[psu.infoIndex]) === SIGNALIZATION_SYSTEM.STATUS.PSU_ERROR ||
          Number(wagonData[evc.groupIndex]?.[evc.infoIndex]) === SIGNALIZATION_SYSTEM.STATUS.EVC_ERROR ||
          Number(wagonData[nvc.groupIndex]?.[nvc.infoIndex]) === SIGNALIZATION_SYSTEM.STATUS.NVC_ERROR ||
          Number(wagonData[btm.groupIndex]?.[btm.infoIndex]) === SIGNALIZATION_SYSTEM.STATUS.BTM_ERROR
        ) {
          setColor(Color.Red);
          return true;
        }

        return false;
      }),
      createColorRule(TCDD_UNIT.TACHOMETER_SPEED_SENSOR_1, (wagonIndex: number, data: any[], setColor: (color: Color) => void) => {
        const wagonData = data?.[TcddSubSystem.SIGNALIZATION_SYSTEM]?.[wagonIndex];
        if (!wagonData) return false;

        const tacho1Broken: ValueIndex = getIndex(SignalizationSystemKeys.tacho1Broken); // === 1 will be red

        if (Number(wagonData[tacho1Broken.groupIndex]?.[tacho1Broken.infoIndex]) === SIGNALIZATION_SYSTEM.STATUS.TACHO_BROKEN) { // Red state
          setColor(Color.Red);
          return true;
        }

        return false;
      }),
      createColorRule(TCDD_UNIT.TACHOMETER_SPEED_SENSOR_2, (wagonIndex: number, data: any[], setColor: (color: Color) => void) => {
        const wagonData = data?.[TcddSubSystem.SIGNALIZATION_SYSTEM]?.[wagonIndex];
        if (!wagonData) return false;

        const tacho2Broken: ValueIndex = getIndex(SignalizationSystemKeys.tacho2Broken); // === 1 will be red

        if (Number(wagonData[tacho2Broken.groupIndex]?.[tacho2Broken.infoIndex]) === SIGNALIZATION_SYSTEM.STATUS.TACHO_BROKEN) { // Red state
          setColor(Color.Red);
          return true;
        }

        return false;
      }),
      createColorRule(TCDD_UNIT.DOPPLER_RADAR_1, (wagonIndex: number, data: any[], setColor: (color: Color) => void) => {
        const wagonData = data?.[TcddSubSystem.SIGNALIZATION_SYSTEM]?.[wagonIndex];
        if (!wagonData) return false;

        const doppler1Broken: ValueIndex = getIndex(SignalizationSystemKeys.doppler1Broken); // === 1 will be red

        if (Number(wagonData[doppler1Broken.groupIndex]?.[doppler1Broken.infoIndex]) === SIGNALIZATION_SYSTEM.STATUS.DOPPLER_BROKEN) { // Red state
          setColor(Color.Red);
          return true;
        }

        return false;
      }),
      createColorRule(TCDD_UNIT.DOPPLER_RADAR_2, (wagonIndex: number, data: any[], setColor: (color: Color) => void) => {
        const wagonData = data?.[TcddSubSystem.SIGNALIZATION_SYSTEM]?.[wagonIndex];
        if (!wagonData) return false;

        const doppler2Broken: ValueIndex = getIndex(SignalizationSystemKeys.doppler2Broken); // === 1 will be red

        if (Number(wagonData[doppler2Broken.groupIndex]?.[doppler2Broken.infoIndex]) === SIGNALIZATION_SYSTEM.STATUS.DOPPLER_BROKEN) { // Red state
          setColor(Color.Red);
          return true;
        }

        return false;
      })
    ];
  }
}
